export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
    }

    showAddAccountButtons() {
        return this.$state.is('company.user-directories.manage-group.accounts')
            && (this.group.type === 'CUSTOM' || this.group.type === 'APPLICATION')
    }

    showAssignApplicationButton() {
        return this.$state.is('company.user-directories.manage-group.applications')
            && this.group.type !== 'APPLICATION'
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/manage-group.controller.js